export default function getResource(label, vars = []) {
    const resources = {
        manageSubscription: 'Gérer l’abonnement',
        qty: 'Qté',
        notRated: 'Aucune note',
        oneReview: 'Un commentaire',
        deliveryEvery: 'Livraison chaque',
        deliveryTitle: 'Fréquence de livraison',
        deliveryValue: `Chaque ${vars[0]}`,
        creditCardExpDate: 'Exp.',
        shippingAddress: 'Adresse de livraison',
        paymentMethod: 'Mode de paiement',
        deliveryFrequency: 'Fréquence de livraison',
        item: `ARTICLE ${vars[0]}`,
        chooseDeliveryFreq: 'Choisir la fréquence de livraison :',
        every: 'Chaque',
        mostCommon: 'Le plus courant',
        youWillSave: 'vous économiserez',
        annualyWithSubs: 'chaque année avec cet abonnement.',
        cancel: 'Annuler',
        frequencyNumber: 'Nombre de fréquence',
        frequencyType: 'Type de fréquence',
        skip: 'Passer',
        pause: 'En pause',
        autoReplenishSummary: 'Sommaire du réapprovisionnement automatique',
        active: 'Actif',
        paused: 'En pause',
        viewShipments: 'Afficher les livraisons',
        biPointsEarned: 'Points Beauty Insider obtenus grâce au réapprovisionnement automatique',
        totalSaving: 'Économies totales sur le réapprovisionnement automatique',
        points: 'points',
        askToUpdateDelivery: 'Vous le voulez plus tôt? Mettez à jour votre fréquence de livraison.',
        cvvSubmitButtonText: 'Confirmer',
        legalCopy: 'Votre carte sera automatiquement facturée en fonction de la fréquence de vos livraisons.',
        cancelSubscription: 'Annuler l’abonnement',
        changeDate: 'Modifier la date',
        nextShipment: 'Prochaine expédition :',
        skuSwapButton: 'Échanger l’article',
        skuSwapUnavailable: 'Aucune autre option pour cet article',
        selectAddress: 'Sélectionner votre adresse',
        selectPayment: 'Sélectionner votre mode de paiement',
        annuallySaving: `${vars[0]}, vous économiserez <b>${vars[1]}</b> chaque année grâce à cet abonnement.`,
        hotDealSaving: `${vars[0]}, vous pouvez toujours économiser <b>${vars[1]}</b> avant le ${vars[2]}.`,
        resumeModalTitle: 'Reprendre l’abonnement',
        resumeSubmitButtonText: 'Reprendre',
        resumeSuccessButtonText: 'Reprendre',
        confirmUpdate: 'Confirm Update',
        current: 'Current',
        updateTo: 'Update to',
        confirmButton: 'Confirm',
        retry: 'Retry',
        updateError: 'We couldn’t update your subscription. Please try again.',
        deliverEveryLabel: 'Deliver every:',
        recurringConsent: 'By tapping confirm, I consent to the reoccurring charge for this subscription.',
        aboutAutoReplenish: 'About Auto-Replenish'
    };

    return resources[label];
}
